export default "__VITE_ASSET__D6V9XSYh__ 300w";